<template>
  <component
    :is="component"
    v-bind="$attrs"
    v-on="$listeners"
    :class="$style.root"
  >
    <slot />
  </component>
</template>

<script>

export default {
  name: 'MenuItem',

  props: {
    component: {
      type: String,
      default: 'li'
    }
  }
}

</script>

<style module>

.root {
  cursor: pointer;

  @apply p-2;
}

.root:hover {
  @apply bg-dull-light;
}

</style>
